/**
 * Chat widget view for the libauth login overlay
 */
import springyView from '../../tools/SpringyView.js';
import { focusFirst } from '../../tools/focusUtil.js';

const authView = Object.create(springyView);

authView.events = {
    'click .btn-cancel': 'closeWidget'
};

/**
 * Wrapper for springyView.init in case we need extra functionality.
 * @param {Object} config Config data.
 * @param {chatWidget} config.model Widget object for this view.
 */
authView.initialize = function(config) {
    config.$el = window.$('#libauth');

    this.init(config);
    if (!this.model.isEmbed()) {
        this.addEvent('keydown', 'trapFocus');
    }
};
/**
 * Hide this view.
 */
authView.hideView = function() {
    this.$el.addClass('hidden');
};
/**
 * Show this view and set focus as appopriate
 */
authView.showView = function() {
    this.$el.removeClass('hidden');
    if (this.model.isEmbed()) {
        return;
    }
    focusFirst(this.el);
};
/**
 * Close/minimize the widget for float, etc. widgets
 */
authView.closeWidget = function() {
    this.model.emitter.trigger('closeWidget');
};
/**
 * Render the view
 * @return {autoView}
 */
authView.render = function() {
    // clear out existing content, events, etc.
    this.$el.empty();

    // render the template and put it in the dom.
    const templateData = {
        auth_id: this.model.get('auth_id'),
        isAuthValidated: this.model.get('isAuthValidated'),
        authText: this.model.get('authText'),
        authUrl: this.model.get('authUrl'),
        authButton: this.model.get('authButton'),
        isEmbed: this.model.isEmbed(),
        cancelButton: this.model.get('cancel_button')
    };
    this.$el.html(this.templateEng.render('overlay_libauth.njk', templateData));

    // Open auth login link in new window if this is an iframe
    if (window !== window.top) {
        const button = this.$el[0].querySelector('.btn-libauth');
        if (button) {
            button.setAttribute('target', '_blank');
        }
    }

    if (!this.model.isEmbed()) {
        focusFirst(this.el);
    }

    return this;
};

export default authView;
